import React from "react";
import Invoice from "./InvoiceList/Invoice";

const InvoiceOperation = () => {
    return <Invoice type="operation" title="Sales invoice" />;
};

export default InvoiceOperation;
